import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import { Typography } from '@mui/material';
// locals
import ImportForm from './ImportForm';
import TreeRuler from './TreePanel/TreeRuler';
import Header from './Header';
import Track from './Track';
import { HorizontalResizeHandle, VerticalResizeHandle } from './ResizeHandles';
import MSAPanel from './MSAPanel';
import TreePanel from './TreePanel';
import Minimap from './Minimap';
const MSAView = observer(function ({ model }) {
    const { done, initialized } = model;
    return (React.createElement("div", null, !initialized ? (React.createElement(ImportForm, { model: model })) : !done ? (React.createElement(Typography, { variant: "h4" }, "Loading...")) : (React.createElement(MSAView2, { model: model }))));
});
const MSAView2 = observer(function ({ model }) {
    const { height, turnedOnTracks, DialogComponent, DialogProps } = model;
    return (React.createElement("div", null,
        React.createElement("div", { style: { height, overflow: 'hidden' } },
            React.createElement(Header, { model: model }),
            React.createElement("div", { style: { position: 'relative' } },
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(TreeRuler, { model: model }),
                    React.createElement(Minimap, { model: model })), turnedOnTracks === null || turnedOnTracks === void 0 ? void 0 :
                turnedOnTracks.map(track => (React.createElement(Track, { key: track.model.id, model: model, track: track }))),
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(TreePanel, { model: model }),
                    React.createElement(VerticalResizeHandle, { model: model }),
                    React.createElement(MSAPanel, { model: model })))),
        React.createElement(HorizontalResizeHandle, { model: model }),
        DialogComponent ? (React.createElement(Suspense, { fallback: null },
            React.createElement(DialogComponent, { ...DialogProps }))) : null));
});
export default MSAView;
//# sourceMappingURL=MSAView.js.map